module.exports = __webpack_public_path__ + "media/boom.38159ef7.mp3";